import { FormValidator, ValidationResult } from '../formField/types/form-validator';

export const RegexValidator: (regex: RegExp, errorMessage: string) => FormValidator = (
  regex: RegExp,
  errorMessage: string
) => {
  return async (value: string): Promise<ValidationResult> => {
    if (!value) {
      return { valid: true };
    }

    if (!regex.test(value)) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    return { valid: true };
  };
};
